import React from 'react'
import { TopicNotSelectedGuard } from 'components/widget/share/guards'
import { WidgetGuard } from 'features/types'

const PreSearchGuard: WidgetGuard = ({ widgetId, children }) => (
  <TopicNotSelectedGuard widgetId={widgetId}>{children}</TopicNotSelectedGuard>
)

export default PreSearchGuard
